import React from 'react'
import { Textarea, Label } from "../ui"

function MixtureInstructions({ mixture, onNoteChange }) {
  return (
    <>
      <Label className="text-gray-500">4. Patient instructions</Label>
      <Textarea
        value={mixture.note || ''}
        onChange={e => onNoteChange(e.target.value)}
        name="notes"
        placeholder="Dosage Notes.."
        className="mb-2"
      />
    </>
  )
}

export default MixtureInstructions
